import type { VariationComponent } from "~types/types";
import {
    type IntegrityStatus,
    checkItemIntegrity,
    checkItemArrayIntegrity,
    checkMediaIntegrity,
} from "~utils/moduleIntegrity";

import { MEDIA_PRIORITY } from "./LineupContentMagazine";

export default function integrityCheck({
    items = [],
    magazineModules = [],
}: VariationComponent): IntegrityStatus {
    const messages: IntegrityStatus = [];

    if (!items?.length) {
        messages.push("This module has no items, please add items.");

        return messages;
    }

    if (items.length < 5) {
        messages.push("This module requires 5 stories minimum.");

        return messages;
    }

    const primaryStoryErrors = checkItemIntegrity(items[0], ["headline"]).map(
        (message: string) => `Primary Story: ${message}`
    );

    messages.push(...checkMediaIntegrity([items[0], items[2]], MEDIA_PRIORITY));

    messages.concat(primaryStoryErrors);

    if (magazineModules[0] && !magazineModules[0].magazineCoverStory) {
        messages.push(
            `There is an issue with the COVER STORY. The cover story must have an associated magazine cover and 2 relatedStories for this module to render`
        );
    }

    const secondaryStoryErrors = checkItemIntegrity(items[2], ["headline"]).map(
        (message: string) => `Third Story: ${message}`
    );

    messages.concat(secondaryStoryErrors);

    const tertiaryStories = items.slice(3);

    const tertiaryStoriesErrors = checkItemArrayIntegrity(tertiaryStories, [
        "headline",
    ]).map((message: string) => `Tertiary Stories: ${message}`);

    messages.concat(tertiaryStoriesErrors);

    return messages;
}
